import { hydrateDropdowns } from "../utils/hydrate-dropdowns";
import { loadClientWidgets } from "../utils/loadClientWidgets";
import { widgetsFootball } from "../widgets";
import { trackPageViews } from "@sky-it-livedata/common-web-app-utils";
import { competitionBoardStickyContainer } from "../utils/competition-board";
import "@sky-it-livedata/livedata-sports-design-system/lib/styles/stylesheet.min.css";
export const initClient = () => loadClientWidgets(widgetsFootball);

initClient();

document.addEventListener("DOMContentLoaded", () => {
  competitionBoardStickyContainer();
  hydrateDropdowns({
    tagsToExclude: [
      "ld-football-competition-calendar-results",
      "ld-football-team-calendar-results",
      "ld-football-last-and-next-match",
      "ld-football-competition-calendar-results",
      "ld-football-team-calendar-results",
      "ld-football-match-reports-details",
      "ld-football-match-reports",
      "ld-football-competition-ranking",
      "ld-football-team-ranking",
      "ld-football-scorers-ranking-player-page",
      "ld-football-competition-predicted-lineups",
      "ld-football-match-predicted-lineups",
      "ld-football-team-players",
      "ld-football-competition-board",
    ],
  });
});

window.addEventListener("competition_board_loaded", () => {
  trackPageViews();
});

window.addEventListener('player_page_statistic_loaded', () => {
  trackPageViews();
});